import { baseSplitApi } from '../baseApi';

const connectPath = "/connect";
const clientPath = `${connectPath}/client`;
let projectDetailTag = "PROJECT_DETAIL_TAG"
let poaProject = "POA_PROJECT"

export const clientProjectApi = baseSplitApi.injectEndpoints({
  endpoints: (build) => ({
    getAllProjectList: build.query({
      query: () => {
        return {
          url: `${clientPath}/project_list`,
          method: 'GET',
        }
      },
    }),
    getProjectDetail: build.query({
      query: ({ projectId, date }) => {
        return {
          url: `${clientPath}/project_detail/${projectId}?date=${date}`,
          method: 'GET',
        }
      },
      providesTags: [projectDetailTag]
    }),
    getProjectDetailById: build.mutation({
      query: (projectId) => {
        return {
          url: `${clientPath}/project_detail/${projectId}`,
          method: 'GET',
        }
      },
      providesTags: [projectDetailTag]
    }),
    uploadDocument: build.mutation({
      query: (data) => {
        return {
          url: `${connectPath}/upload_project_document`,
          body: data,
          method: 'POST',
        }
      },
      invalidatesTags: [projectDetailTag],
    }),
    addPM: build.mutation({
      query: ({ payload, projectCode }) => {
        return {
          url: `${clientPath}/add_pm/${payload._id}`,
          method: 'POST',
          body: { pmDetails: payload.el, projectCode: projectCode }
        }
      }
    }),
    approvePOA: build.mutation({
      query: (payload) => {
        return {
          url: `${connectPath}/approve`,
          method: 'POST',
          body: { projectID: payload.projectId }
        }
      },
      invalidatesTags: [poaProject]
    }),
    getPOAProject: build.query({
      query: (payload) => {
        return {
          url: `${connectPath}/poa_project/${payload.projectId}`,
          method: 'GET',
        }
      },
      providesTags: [poaProject]
    }),
    updateFeedBack: build.mutation({
      query: body => {
        return {
          url: `${connectPath}/feedback`,
          method: 'POST',
          body: body
        }
      },
      invalidatesTags: [poaProject]
    }),
    getAllCountries: build.query({
      query: () => {
        return {
          url: `${clientPath}/countries`
        }
      }
    }),
    getAllRegions: build.query({
      query: () => {
        return {
          url: `${clientPath}/regions`
        }
      }
    }),
    getGraphRelatedData: build.query({
      query: () => {
        return {
          url: `${connectPath}/client_dashboard_graph_data`
        }
      }
    }),
    getOngoingProjects: build.query({
      query: () => {
        return {
          url: `${clientPath}/ongoing_projects`,
          method: 'GET',
        }
      }
    }),
    getPendingInvoices: build.query({
      query: () => {
        return {
          url: `${clientPath}/pending_invoices`,
          method: 'GET'
        }
      }
    }),
    getInvoicedProjects: build.query({
      query: () => {
        return {
          url: `${connectPath}/invoiced_project`,
          method: 'GET'
        }
      },
      transformResponse: response => response.data
    }),
    getGraphRelatedData: build.query({
      query: (clientCode) => {
        return {
          url: `${connectPath}/client_dashboard_graph_data?clientCode=${clientCode}`
        }
      }
    }),
    getTotalProjectData: build.query({
      query: ({ pmEmail,clientCode, fromDate, toDate }) => {
        return {
          url: `${connectPath}/total_projects_graph?clientCode=${clientCode}&fromDate=${fromDate}&toDate=${toDate}&pmEmail=${pmEmail}`
        }
      }
    }),
    getSampleCountData: build.query({
      query: ({ pmEmail,clientCode, fromDate, toDate }) => {
        return {
          url: `${connectPath}/sample_count_graph?clientCode=${clientCode}&fromDate=${fromDate}&toDate=${toDate}&pmEmail=${pmEmail}`
        }
      }
    }),
    getCpiData: build.query({
      query: ({ pmEmail,clientCode, fromDate, toDate }) => {
        return {
          url: `${connectPath}/cpi_graph?clientCode=${clientCode}&fromDate=${fromDate}&toDate=${toDate}&pmEmail=${pmEmail}`
        }
      }
    }),
    getRevenueData: build.query({
      query: ({ pmEmail,clientCode, fromDate, toDate }) => {
        return {
          url: `${connectPath}/revenue_graph?clientCode=${clientCode}&fromDate=${fromDate}&toDate=${toDate}&pmEmail=${pmEmail}`
        }
      }
    }),
    approveTestSynopsisTable: build.mutation({
      query: body => {
        return {
          url: `${connectPath}/approve_test_synopsis_table`,
          method: 'POST',
          body: { payload: body }
        }
      },
      invalidatesTags: [projectDetailTag],
    }),
    approveTestSynopsis: build.mutation({
      query: body => {
        return {
          url: `${connectPath}/approve_test_synopsis`,
          method: 'POST',
          body: { payload: body }
        }
      },
      invalidatesTags: [projectDetailTag],
    }),
    approveInvoice: build.mutation({
      query: body => {
        return {
          url: `${connectPath}/approve_invoice`,
          method: "POST",
          body
        }
      },
      invalidatesTags: [projectDetailTag]
    })
  }),
})

// These hooks gets auto generated based on endpoints
export const { useGetAllProjectListQuery, useGetAllCountriesQuery, useGetAllRegionsQuery, useGetProjectDetailQuery, useGetProjectDetailByIdMutation, useUploadDocumentMutation, useGetInvoicedProjectsQuery, useAddPMMutation, useApprovePOAMutation, useGetPOAProjectQuery, useUpdateFeedBackMutation, useGetGraphRelatedDataQuery, useGetOngoingProjectsQuery, useGetPendingInvoicesQuery, useApproveTestSynopsisMutation, useApproveTestSynopsisTableMutation, useApproveInvoiceMutation,useGetCpiDataQuery,useGetRevenueDataQuery,useGetTotalProjectDataQuery,useGetSampleCountDataQuery } = clientProjectApi;